var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bPrompt)?_c('div',[_c('h1',[_vm._v("I am first div.")]),_c('button',{on:{"click":_vm.turnOver}},[_vm._v("切换")])]):_c('div',[_c('h1',[_vm._v("I am second div.")]),_c('button',{on:{"click":_vm.turnOver}},[_vm._v("切换")])])}
var staticRenderFns = []

export { render, staticRenderFns }